import { render } from "./FKstime.vue?vue&type=template&id=7827d33c&scoped=true"
import script from "./FKstime.vue?vue&type=script&lang=js"
export * from "./FKstime.vue?vue&type=script&lang=js"

import "./FKstime.vue?vue&type=style&index=0&id=7827d33c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7827d33c"]])

export default __exports__